import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTaskStages(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/task_stage/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchTaskStage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/task_stage/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addTaskStage(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/task_stage', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    }

  },
}
